import request from "@/service";

/* 查询请假审核列表 */
export function leaveAuditList(data) {
  return request({
    url: "/study/audit/enroll/leaveAuditPage",
    method: "get",
    params: data
  });
}

// 获取审核详情
export function getLeaveAuditDetail(id) {
  return request({
    url: `/study/audit/enroll/leaveAuditByUuid/${id}`,
    method: "get"
  });
}

// 获取请假审核记录
export function auditHistoryList(id) {
  return request({
    url: `/study/audit/enroll/leaveAuditDetail/${id}`,
    method: "get"
  });
}

// 更新审核记录
export function auditHistoryUpdate(data) {
  return request({
    url: `/study/audit/enroll/auditHistoryUpdate`,
    method: "post",
    data
  });
}

// 获取请假审核人列表
export function leaveAuditorList(id) {
  return request({
    url: `/user/userAdd/audit/leaveExaminerList/${id}`,
    method: "get"
  });
}

// 
export function userAuditorList(auditApplyId) {
  return request({
    url: `/study/audit/enroll/userAuditorList/${auditApplyId}`,
    method: "get"
  });
}
// 审核记录推送
export function auditHistoryPush(uuid) {
  return request({
    url: `/study/audit/enroll/auditHistoryPush/${uuid}`,
    method: "get"
  });
}

// 获取请假短信内容-wangxf
export function getSmsContent(data) {
  return request({
    url: `/study/audit/enroll/getSmsContent`,
    method: "post",
    data
  });
}

export function getSmsContentNew(data) {
  return request({
    url: `/study/audit/enroll/getSmsContentList`,
    method: "post",
    data
  });
}

